var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCalendarArrowLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
  fill: "#F1F7FA"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9613 15.7054L16.5387 12.128C16.7014 11.9653 16.9652 11.9653 17.128 12.128L17.7141 12.7142C17.8767 12.8767 17.8769 13.1402 17.7145 13.303L15.025 16.0001L17.7145 18.6971C17.8769 18.8599 17.8767 19.1234 17.7141 19.2859L17.128 19.8721C16.9652 20.0348 16.7014 20.0348 16.5387 19.8721L12.9613 16.2947C12.7986 16.132 12.7986 15.8681 12.9613 15.7054Z",
  fill: "#8291A4"
})));
export default SvgCalendarArrowLeft;